import { Info } from "lucide-react";

export function MaintenanceBanner() {
  const isEnabled = import.meta.env.VITE_MAINTENANCE_BANNER_ENABLED === "true";
  const message = import.meta.env.VITE_MAINTENANCE_BANNER_MESSAGE;

  if (!isEnabled || !message) return null;

  return (
    <div className="w-full bg-curtin-tertiary-banana px-6 py-3 text-sm text-curtin-secondary-gray-01">
      <p className="mx-auto flex max-w-screen-xl items-center gap-4">
        <Info className="h-5 w-5 flex-shrink-0" />
        <span>{message}</span>
      </p>
    </div>
  );
}
